// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"727":"9667b57ae13d35f4bbd9","879":"0fd9977826325f48454f"}[chunkId] + ".js";
};